<template lang="pug">
	modal(:max-width="700")
		.card.text-left
			.card-header
				span.fa.fa-edit.mr-2
				span Tarea realizada
				button.close(@click="cerrar") &times;
			.card-body
				.row
					.col
						b ¿En qué galería está el trabajo realizado?
					.col
						.input-group
							.input-group-prepend
								.input-group-text
									span.fa.fa-search
							input.form-control.form-control-sm(placeholder="buscar", v-model="cadena", @keypress.enter="buscarGalerias")

			.card-body.bg-light(
				style="border-top: 1px solid #e0e0e0;"
				v-if="!seleccion"
			)
				// Listado de galerías
				MiniGaleria(
					v-for="(galeria, i) in galerias",
					:key="galeria.GaleriaID",
					:galeria="galeria",
					@selecciona="selecciona($event)"
				)
			.card-body(v-else="seleccion")
				.row
					.col.text-center
						MiniGaleria(
							:key="seleccion.GaleriaID",
							:galeria="seleccion",
							@selecciona="selecciona($event)"
						)
					.col
						.form-group
							label
								b Comentarios finales
							textarea.form-control(
								rows="6"
								placeholder="Escribe algún comentario si es necesario aclarar algo"
								v-model="datos.ComentariosFinales"
							)

			.card-footer(v-if="seleccion")
				button.btn.btn-primary(@click="confirmar")
					span.fa.fa-check.mr-2
					span Confirmar
</template>

<script>
import axios from 'axios'
import MiniGaleria from '../../../../galerias/vue/componentes/listado-galerias/mini-galeria'
export default {
	props: ['TareaID'],
	data () {
		return {
			cadena: '',
			galerias: [],
			seleccion: null,
			datos: {
				TareaID: null,
				ComentariosFinales: '',
				GaleriaID: null
			}
		}
	},
	components: {
		MiniGaleria
	},
	created () {
		this.buscarGalerias()
	},
	methods: {
		buscarGalerias () {
			axios.post('produccion-audiovisual/php/api/buscaGalerias.php', {cadena: this.cadena})
				.then(res => {
					this.galerias = res.data
				})
				.catch(this.$responseError)
		},
		selecciona (ev) {
			const sel = this.galerias.filter(g => g.GaleriaID === ev)[0]
			this.seleccion = sel === this.seleccion ? null : sel
		},
		confirmar () {
			this.datos.TareaID = this.TareaID
			this.datos.GaleriaID = this.seleccion.GaleriaID

			if (!this.datos.GaleriaID) {
				this.$error('Error', 'Debes seleccionar una galería')
				return
			}

			axios.post('produccion-audiovisual/php/api/finalizar.php', this.datos)
				.then(res => {
					this.$store.commit('toast/success', {
						titulo: 'Tarea finalizada'
					})
					this.$emit('finalizada')
					this.cerrar()
				})
				.catch(this.$responseError)
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/produccion-audiovisual/vue/components/detalles/tareaRealizada.component.vue